const ENUMS = {
    META: 'META',
    PIPE: '|',
    END: ';',
};

module.exports = ENUMS;
